// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.CAMPAIGN_MATCHES.name];

const campaignMatchesApi = {
  getDailyMatches(campaignId) {
    return client.get(`/${campaignId}.tsv`)
      .then((response) => response.data);
  },
};
export default campaignMatchesApi;
